export default __webpack_public_path__ + "static/media/1874.ee827581.png";